import { Dialog } from "@progress/kendo-react-dialogs";
import React from "react";
import "./report.css";
import { Checkbox, RadioButton } from "@progress/kendo-react-inputs";
import DatePicker from "react-datepicker";
import { CustomDatePicker } from "../../../components/custom/datepicker";
import moment from "moment";

export const Filter = (props) => {
  return (
    <Dialog width={395} height={"100%"} className="report_filter_dialog">
      <div className="report_filter_main_box">
        <div style={{ position: "relative" }}>
          <div
            className="report_filter_cross_icon"
            onClick={() => props.setShowFilter(false)}
          >
            <span class="k-icon k-font-icon k-i-close k-icon-xl" />
          </div>
        </div>
        <div className="report_filter_header_box">
          <div className="report_filter_header_title">Filter</div>
          <div
            className="report_filter_header_clear_filter"
            onClick={props.filterClearAction}
          >
            Clear Filter
          </div>
        </div>
        <div className="report_filter_detail_main_box">
          <div className="report_filter_detail_date">
            <div className="report_filter_detail_date_child">
              <div>From</div>
              <DatePicker
                dateFormatCalendar="MMMM"
                customInput={<CustomDatePicker />}
                // minDate={new Date()}
                selected={
                  props.filterValue.start_date !== ""
                    ? new Date(props.filterValue.start_date)
                    : ""
                }
                onChange={(e) =>
                  props.setFilterValue({
                    ...props.filterValue,
                    start_date: moment(e).format("YYYY-MM-DD"),
                  })
                }
              />
            </div>
            <div className="report_filter_detail_date_child">
              <div>To</div>
              <DatePicker
                dateFormatCalendar="MMMM"
                customInput={<CustomDatePicker />}
                // minDate={new Date()}
                selected={
                  props.filterValue.end_date !== ""
                    ? new Date(props.filterValue.end_date)
                    : ""
                }
                onChange={(e) =>
                  props.setFilterValue({
                    ...props.filterValue,
                    end_date: moment(e).format("YYYY-MM-DD"),
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="report_filter_footer_main_box">
          <div
            className="report_filter_footer_cancel"
            onClick={() => props.setShowFilter(false)}
          >
            Cancel
          </div>
          <div
            className="report_filter_footer_submit"
            onClick={props.FilterAction}
          >
            Submit
          </div>
        </div>
      </div>
    </Dialog>
  );
};
